<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item v-if='addBoolean' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Alarm.add")' :click='notices' eventType='add'></e-item>
        <e-item v-if='deleteBoolean' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Alarm.remove")' :click='notices' eventType='remove'></e-item>
        <e-item v-if='editBoolean' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Alarm.edit")' :click='notices' eventType='edit'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
        <e-item v-if='ableBoolean' prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Alarm.able")' :click='notices' eventType='able'></e-item>
        <e-item v-if='disableBoolean' prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Alarm.disable")' :click='notices' eventType='disable'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>
<script>
export default {
  name: 'alarmNoticeTableButton',
    data() {
    return {
      addBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_notice.Add,
      deleteBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_notice.Delete,
      editBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_notice.Modify,
      ableBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_notice.Enable,
      disableBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_notice.Disable,
    };
  },
  methods: {
    notices(args) {
      this.$emit('notice', args.item.eventType);
    }
  }
};
</script>